import { Role } from '@/core/components/auth/auth.types'
import { LoadingList } from '@/core/components/LoadingList'
import { activityByIdQueryOptions } from '@/core/components/sites/site/activities-and-products/activitiesQueryOptions'
import { promoCodeQueryOptions } from '@/core/components/sites/site/rates-and-packages/promo-code/promoCodeQueryOptions'
import { cancellationPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/policiesQueryOptions'
import { taxAndFeesPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/taxAndFeesQueryOptions'
import { defer, ErrorComponent, redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const activitiesSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z.enum(['id', 'name', 'price', 'maxAttendee']).catch('name'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/activities-and-products/$activityId/edit/'
)({
  validateSearch: (search) => activitiesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({
    context: { queryClient, auth },
    params: { siteId, activityId },
  }) => {
    const promoCodesDefer = defer(
      queryClient.ensureQueryData(promoCodeQueryOptions(siteId, auth.token!))
    )

    const taxes = defer(
      queryClient.ensureQueryData(
        taxAndFeesPoliciesQueryOptions(siteId, auth.token!)
      )
    )
    const cancelation = defer(
      queryClient.ensureQueryData(
        cancellationPoliciesQueryOptions(siteId, auth.token!)
      )
    )

    const activity = queryClient.ensureQueryData(
      activityByIdQueryOptions(siteId, activityId, auth.token!)
    )
    return {
      taxes,
      cancelation,
      promoCodesDefer,
      activity,
    }
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
